import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { updateIntent } from '../../actions/intents.js';
import '../../../styles/scss/style.css';

//Components
import QuestionBuilder from './QuestionBuilder';
import AnswerBuilder from './AnswerBuilder';
import SubSubjectTitle from '../molecules/SubSubjectTitle';

//Returning the component
class ConversationBuilder extends Component {
	state = { data: this.props.data }

	handleSave = (id, newData) => {
		const { data } = this.state;
		const intentIndex = data.findIndex(d => d._id === id);
		data[intentIndex] = { ...this.state.data[intentIndex], ...newData };
		this.setState({ data });
		updateIntent(id, { ...this.state.data[intentIndex], ...newData })
			.catch(err => console.error(err));
	}

	handleSubmit = (id, name) => {
		const intent = this.props.data.find(d => d._id === id);
		updateIntent(intent._id, { ...intent, name })
			.catch(err => console.error(err));
	}

	renderIntents(intents) {
		return intents.map(intent => (
			<div key={intent._id} className="dashboardPanelContainer">
				<div className="dashboardPanel">
					<div className="dashboardPanel__content">
					<SubSubjectTitle id={intent._id} subSubjectTitle={intent.name} handleSubmit={this.handleSubmit} />
					<div className="conversationBuilder">
						<QuestionBuilder
							placeholder={this.props.placeholderQuestion}
							name={this.props.nameQuestion}
							form={this.props.formQuestion}
							onChange={this.props.onChangeQuestion}
							handleSave={this.handleSave}
							data={intent.actions}
							id={intent._id}
						/>
						<AnswerBuilder
							placeholder={this.props.placeholderAnswer}
							answerNumber={this.props.answerNumber}
							handleSave={this.handleSave}
							data={intent.reactions}
							id={intent._id}
						/>
					</div>
				</div>
			</div>
		</div>
		))
	}

	render() {
		return <div>{this.renderIntents(this.props.data)}</div>
	}
}

export default withRouter(ConversationBuilder);





// WEBPACK FOOTER //
// ./src/redux/components/organisms/ConversationBuilder.jsx